<div class="relative h-full w-full min-w-0 pt-1">
  <p-chart
    type="bar"
    [options]="options"
    [data]="data"
    [plugins]="plugins"
    [responsive]="true"
    width="100%"
    height="100%"
  />
</div>
